module.exports = __webpack_public_path__ + "media/images/icons/filled/medium-circle-3647e9d218abe2d39f6d05614a1c95ec.svg";